// Tiny script to fix price display - extremely lightweight
document.addEventListener('DOMContentLoaded', function() {
  // Get all prices with money formatting
  const moneyElements = document.querySelectorAll('.money');
  
  // Extract just the price value
  moneyElements.forEach(el => {
    const text = el.textContent.trim();
    // If it contains a currency symbol followed by numbers, extract just that part
    const match = text.match(/[$£€¥][0-9.,]+/);
    if (match) {
      el.textContent = match[0];
    }
  });
});
